// extracted by mini-css-extract-plugin
export default {"container":"PieChartCardReport_container__SnwmT","percentageContainer":"PieChartCardReport_percentageContainer__R1gWB","colorBox":"PieChartCardReport_colorBox__RpUDR"};